import { styled, CardContent, Box } from '@mui/material';

export const DashboardOrdersReportCardContent = styled(CardContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 3),

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  }),
);

export const DashboardOrdersReportChartContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 300,
  marginTop: theme.spacing(1),
}));
